import React from "react";
import { WrapperPage } from "../../../components/shared/WrapperPage";
import SuspenseComp from "../../../components/shared/SuspenseComp";
import { SkeletonPagePolaris } from "../../../components/shared/SkeletonPagePolaris";
import TiktokProductTemplates from "../../../components/tiktok/product-templates/TiktokProductTemplates"

export default function TiktokProductTeamplatesPage() {
	return (
		<WrapperPage>
			<SuspenseComp fallback={<SkeletonPagePolaris />}>
				<TiktokProductTemplates />
			</SuspenseComp>
		</WrapperPage>
	);
}
